import { render, staticRenderFns } from "./TabelaDespesasFixas.vue?vue&type=template&id=4101fb8a&"
import script from "./TabelaDespesasFixas.vue?vue&type=script&lang=js&"
export * from "./TabelaDespesasFixas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports